import React from 'react'
import { Link } from '@tanstack/react-router'
import type { LinkProps } from '@tanstack/react-router'
import { Span, ChevronRightIcon } from '@/components/atoms'

interface LinkCardProps {
  to?: LinkProps['to']
  label: string
  icon?: React.ReactNode
  onClick?: () => void
  'data-testid'?: string
}

function CardContent({
  label,
  icon,
}: {
  label: string
  icon?: React.ReactNode
}) {
  return (
    <div className="m-auto flex w-full items-center justify-between">
      <div className="flex items-center gap-3">
        {icon}
        <Span className="text-left text-base font-semibold text-indigo-900">
          {label}
        </Span>
      </div>
      <ChevronRightIcon className="h-6 w-6 text-neutral-600" />
    </div>
  )
}

const cardClass =
  'flex rounded-lg border border-neutral-100 bg-white py-8 px-[2.69rem] h-full  w-full md:max-w-[29.028rem] md:min-h-[6.25rem]'

export function LinkCard({
  to,
  label,
  icon,
  onClick,
  'data-testid': testId,
}: LinkCardProps) {
  if (to) {
    return (
      <Link to={to} className={cardClass} data-testid={testId}>
        <CardContent label={label} icon={icon} />
      </Link>
    )
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${cardClass} cursor-pointer text-left`}
      title={label}
      data-testid={testId}
    >
      <CardContent label={label} icon={icon} />
    </button>
  )
}
